import React from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";

// Slick carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ✅ Free Unsplash background images for each card
const backgrounds = [
    "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&w=800&q=80",
];

// ✅ Project list
const projects = [
    "Educational Courses & E-Learning",
    "Functional Skills Courses",
    "Training & Career Advancement",
    "Language Courses",
    "Vocational Courses",
    "Short Courses",
    "IT Training",
    "SIA Training",
];

export default function TestimonialSlides() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <Box
            sx={{
                width: "100%",
                py: 6,
                backgroundColor: "#f9f9f9",
            }}
        >
            <Slider {...settings}>
                {projects.map((name, index) => (
                    <Box
                        key={index}
                        sx={{
                            height: 260,
                            maxWidth: 380,
                            mx: "auto",
                            borderRadius: 3,
                            overflow: "hidden",
                            position: "relative",
                            cursor: "pointer",
                            transition: "0.3s",
                            "&:hover": {
                                transform: "scale(1.04)",
                            },

                            // ✅ Background image
                            backgroundImage: `url(${backgrounds[index]})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                        }}
                    >
                        {/* ✅ Frosted overlay */}
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                background: "rgba(0,0,0,0.55)",
                                backdropFilter: "blur(3px)",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "white",
                                textAlign: "center",
                                px: 2,
                            }}
                        >
                            <SchoolIcon sx={{ fontSize: 50, color: "goldenrod", mb: 2 }} />

                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: "bold",
                                    lineHeight: 1.3,
                                }}
                            >
                                {name}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Slider>
        </Box>
    );
}
